import { Component } from '@theme/component';

/**
 * Submits the localization form when the user selects a different country.
 *
 * @typedef {Object} FooterLocaleRefs
 * @property {HTMLFormElement} localizationForm
 * @property {HTMLSelectElement} countrySelect
 */

/** @extends {Component<FooterLocaleRefs>} */
class SfFooterLocale extends Component {
  connectedCallback() {
    super.connectedCallback();
  }

  /** @param {Event} _event */
  handleCountryChange(_event) {
    this.refs.localizationForm.submit();
  }
}

if (!customElements.get('sf-footer-locale')) {
  customElements.define('sf-footer-locale', SfFooterLocale);
}
